// Generated by tools/gen-prop-catalog — do not edit manually.
// Re-generate: cargo run -p gen-prop-catalog > client/src/data/prop-catalog.ts
// Rust version dependency: hash output tied to rust-toolchain.toml pin.

const CATALOG: ReadonlyMap<number, string> = new Map([
  [12367589, "Nails"],
  [18083389, "Gold Ingot"],
  [48194497, "Wheat"],
  [59145930, "Wine"],
  [83522278, "Elm Tree"],
  [96581238, "Fish Stew"],
  [124534192, "Trapping Station"],
  [127738167, "Cooked Meat"],
  [164222944, "Sand"],
  [164867657, "Cheese"],
  [211150799, "Gemstone"],
  [214541165, "Bedroll"],
  [218399179, "Iron Ore"],
  [227894113, "Coal"],
  [229668824, "Fossil"],
  [232401165, "Iron Vein"],
  [247624561, "Herb Seed"],
  [270703156, "Oak Tree"],
  [307070873, "Bone Needle"],
  [339195809, "Alchemy Bench"],
  [395421233, "Dried Meat"],
  [417032028, "Sand Bank"],
  [446412907, "Baked Goods"],
  [450134433, "Berry Tart"],
  [490029933, "Gold Nugget"],
  [510139061, "Grain"],
  [525831498, "Vinegar"],
  [530806220, "Loom"],
  [538867801, "Cooked Fish"],
  [553053231, "Stone Knife"],
  [554026110, "Bread"],
  [554934776, "Herbal Tea"],
  [563649199, "Chicken Coop"],
  [614406464, "Sulfur"],
  [640270456, "Cloth"],
  [653431454, "Reed Seed"],
  [665983899, "Stonecutting Table"],
  [677245670, "Butter"],
  [680795401, "Geode Node"],
  [684232530, "Cobbler's Bench"],
  [758598460, "Compost"],
  [784967740, "Woad Plant"],
  [797242629, "Quartz Crystal"],
  [806315003, "Forge"],
  [815660798, "Straw Hat"],
  [817626223, "Amethyst"],
  [825894490, "Cultivated Reed"],
  [828056392, "Ink"],
  [832379723, "Fiber"],
  [852392167, "Glass"],
  [863178635, "Bat Guano"],
  [890149361, "Stone"],
  [894438023, "Quill"],
  [896127969, "Raw Meat"],
  [901608202, "Cow Carcass"],
  [924622010, "Wheat Seed"],
  [1038607142, "Chair"],
  [1053161120, "Table"],
  [1075303529, "Food Source"],
  [1079756578, "Guard Post"],
  [1086629907, "Candle"],
  [1094564276, "Community Stockpile"],
  [1104283235, "Root Cellar"],
  [1137594440, "Flour"],
  [1150632642, "Mangrove Tree"],
  [1153335352, "Raw Fish"],
  [1163437249, "Carved Figurine"],
  [1176898034, "Tin Vein"],
  [1185029824, "Clay"],
  [1190567299, "Planks"],
  [1193909376, "Bandage"],
  [1197930673, "Flower Crown"],
  [1212228559, "Mushroom Cluster"],
  [1234377205, "Yarn"],
  [1238946466, "Iron Tonic"],
  [1244989387, "Roasted Mushrooms"],
  [1251770896, "Ice House"],
  [1268731786, "Yellow Dye"],
  [1288146056, "Cheese Bread"],
  [1319798058, "Marble Vein"],
  [1322756485, "Stone Axe"],
  [1325750787, "Feather"],
  [1345503562, "Berry Plant"],
  [1406060366, "Trapdoor"],
  [1422351345, "Pear Tree"],
  [1452528518, "Madder Plant"],
  [1497299973, "Stalagmite Column"],
  [1502806279, "Tin Ingot"],
  [1515492837, "Gold Vein"],
  [1535067248, "Smoked Fish"],
  [1594398076, "Totem"],
  [1635677830, "Stone Node"],
  [1635795089, "Silver Vein"],
  [1637515580, "Storage Chest"],
  [1664493784, "Ladder"],
  [1686869959, "Weld Plant"],
  [1704406325, "Copper Vein"],
  [1708927455, "Maple Tree"],
  [1719502023, "Cotton Seed"],
  [1760055855, "Cactus"],
  [1777322426, "Rest Spot"],
  [1839652693, "Hunting Blind"],
  [1854048855, "Egg"],
  [1855668062, "Campfire"],
  [1864164414, "Leather Bag"],
  [1869077649, "Kiln"],
  [1874772732, "Seashell"],
  [1902972484, "Apple"],
  [1906474912, "Stairs"],
  [1928896597, "Wood Log"],
  [1955836484, "Underground Spring"],
  [1968804162, "Barn"],
  [1998323896, "Prepared Bait"],
  [2003762023, "Herbs"],
  [2011789439, "Wood"],
  [2024948344, "Egg Scramble"],
  [2049843207, "Palm Tree"],
  [2050642445, "Boar Carcass"],
  [2058386937, "Cave Mushroom Cluster"],
  [2060420711, "Jerky"],
  [2070193598, "Rope"],
  [2108360426, "Wool"],
  [2125461596, "Freshwater Spring"],
  [2141380552, "Bird Nest"],
  [2171866797, "Fishing Spot"],
  [2173625225, "Red Dye"],
  [2193647819, "Snare"],
  [2208332338, "Wall Torch"],
  [2226280740, "Healing Salve"],
  [2260318496, "Tallow"],
  [2298023140, "Window"],
  [2302159828, "Deadfall Trap"],
  [2312380050, "Herb Patch"],
  [2372335619, "Cotton Plant"],
  [2386375935, "Silver Ore"],
  [2397688627, "Tide Pool"],
  [2400364059, "Clay Deposit"],
  [2404624451, "Blue Dye"],
  [2421581800, "Tanning Rack"],
  [2424894370, "Chicken Carcass"],
  [2464379157, "Wooden Shield"],
  [2477063528, "Clay Pot"],
  [2488146971, "Meat Stew"],
  [2507755594, "Mushrooms"],
  [2524848959, "Pine Tree"],
  [2531447063, "Mica Flake"],
  [2573970598, "Shelter"],
  [2584347857, "Sheep Pen"],
  [2584539367, "Herbal Brew"],
  [2597657364, "Mortar"],
  [2599062700, "Herb Plant"],
  [2615223993, "Knitted Clothing"],
  [2618704976, "Crop Plot"],
  [2637519043, "Mica Seam"],
  [2639888285, "Rabbit Carcass"],
  [2676907539, "Honey Bread"],
  [2684421854, "Torch"],
  [2686200220, "Waterskin"],
  [2689348276, "Fine Cloth"],
  [2692590257, "Anvil"],
  [2704326311, "Iron Ingot"],
  [2706132277, "Tilled Soil"],
  [2737701630, "Reed Bed"],
  [2754663627, "Copper Ingot"],
  [2786901498, "Bronze Ingot"],
  [2815348937, "Yellow Pigment"],
  [2849743051, "Bone"],
  [2882009627, "Morning Dew Herb"],
  [2913104461, "Charcoal"],
  [2916521346, "Fir Tree"],
  [2940589531, "Wild Wheat"],
  [2963302432, "Blue Pigment"],
  [3012725247, "Obsidian"],
  [3017779306, "Raw Berries"],
  [3017821832, "Geode"],
  [3021967274, "Pear"],
  [3104609108, "Reed"],
  [3107070873, "Wildflower"],
  [3121560973, "Honeycomb"],
  [3124418209, "Down"],
  [3128199131, "Dye Barrel"],
  [3133560164, "Oven"],
  [3195396643, "Marble Block"],
  [3229844666, "Wooden Door"],
  [3237196440, "Well"],
  [3239955197, "Fence"],
  [3250860326, "Sleeping Draught"],
  [3255600664, "Leather Armor"],
  [3312509483, "Fossil"],
  [3351634781, "Milk"],
  [3368693678, "Cotton Plant"],
  [3394543989, "Dew Herb"],
  [3398710525, "Berry Bush"],
  [3415585302, "Night Mushroom"],
  [3438212983, "Obsidian Shard"],
  [3465779809, "Soap"],
  [3485474078, "Essence"],
  [3489114673, "Berry Seed"],
  [3489845047, "Cave Moss"],
  [3491300924, "Mead"],
  [3525913669, "Cured Leather"],
  [3559505369, "Water Flask"],
  [3561563202, "Bellows"],
  [3562264048, "Salt"],
  [3609330274, "Stew"],
  [3638436658, "Leather"],
  [3652467089, "Fishing Rod"],
  [3653144851, "Tin Ore"],
  [3659658340, "Sulfur Vent"],
  [3682470516, "Cut Stone"],
  [3685094696, "Irrigation Channel"],
  [3696022173, "Meat Pie"],
  [3701958584, "Coal Seam"],
  [3713403019, "Small Hide"],
  [3722355754, "Spinning Wheel"],
  [3724912373, "Cooked Meal"],
  [3727707182, "Stone Hoe"],
  [3728453840, "Brick"],
  [3747775576, "Smokehouse"],
  [3772687731, "Brewing Barrel"],
  [3776962672, "Story Stone"],
  [3811691073, "Cave Mouth"],
  [3817972492, "Drum"],
  [3830208814, "Willow Tree"],
  [3861323822, "Red Pigment"],
  [3870512889, "Workbench"],
  [3879981188, "Ale"],
  [3902930013, "Cider"],
  [3940496682, "Birch Tree"],
  [3951699735, "Animal Hide"],
  [3953229270, "Apple Tree"],
  [3967953747, "Flowstone Sheet"],
  [3989541821, "Glowing Mushroom"],
  [4005352807, "Deer Carcass"],
  [4009791357, "Thread"],
  [4020470908, "Stone Wheel"],
  [4021805230, "Sheep Carcass"],
  [4026871710, "Wall Section"],
  [4068020178, "Clean Water"],
  [4084582379, "Bed"],
  [4127079903, "Stalactite Deposit"],
  [4170983854, "Cave Ore Vein"],
  [4175498630, "Writing Desk"],
  [4191379597, "Copper Ore"],
  [4238014783, "Beehive"],
  [4238793420, "Salt Flat"],
  [4239841572, "Pit Trap"],
  [4251130734, "Wildflower Patch"],
  [4293928509, "Sewing Table"],
]);

export function propLabel(kind: number): string {
  return CATALOG.get(kind) ?? `Prop #${kind}`;
}

export { CATALOG as PROP_CATALOG };
